import React, { useState } from 'react'

import { useDashboard } from 'redux/hooks/Dashboards'
import { useDashboardGroup } from 'redux/hooks/DashboardGroups'
import { useAccountSettings } from 'redux/hooks/SignedInAccount'

import Box from 'components_new/atoms/Box'
import Button from 'components_new/atoms/Button'
import Collapse from 'components_new/atoms/Collapse'
import Text from 'components_new/atoms/Text'
import Icon from 'components_new/atoms/Icon'
import Tooltip from 'components_new/atoms/Tooltip'

import AboutDashboardDialog from 'components_new/organisms/dialogs/AboutDashboardDialog'
import { useEditMode } from 'redux/hooks/DashboardPage'

import { useParams } from 'utils/hooks'
import { DashboardStatus } from 'types/GlobalDashboardGroup'
import { useTranslation } from 'language/translator'

interface PublishBarProps {
  sx?: object
}

const PublishBar = (props: PublishBarProps) => {
  const { sx } = props

  const params = useParams<{ id: string }>()
  const dashboard = useDashboard(params.id)
  const group = useDashboardGroup(dashboard?.dashboard_group_id || null)
  const editMode = useEditMode()
  const { dashboardLimitReached } = useAccountSettings()
  const { t } = useTranslation()
  const [dialog, setDialog] = useState<boolean>(false)

  // loading
  if (!dashboard || !group) {
    return null
  }

  // success
  return (
    <Collapse
      in={group.status === DashboardStatus.DRAFT && !editMode}
      unmountOnExit={true}
    >
      <Box
        sx={{
          bgcolor: 'info.background',
          py: 0.5,
          pl: 2,
          pr: 4,
          width: '100%',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          ...sx
        }}
      >
        <Text color="info.contastText">
          <b>{t('global', 'unpublished')}.</b>{' '}
          {t('dashboards', 'dashboard_not_visible')}
        </Text>
        <Tooltip
          title={
            dashboardLimitReached
              ? t('dashboards', 'dashboard_limit_reached_tooltip')
              : ''
          }
        >
          <span>
            <Button
              color="primary"
              disabled={dashboardLimitReached}
              onClick={() => setDialog(true)}
              size="small"
              startIcon={<Icon name="Published" />}
              variant="text"
            >
              {t('global', 'publish')}
            </Button>
          </span>
        </Tooltip>
      </Box>

      <AboutDashboardDialog
        dashboardGroup={group}
        onClose={() => setDialog(false)}
        open={dialog}
        variant="publish"
        setVariant={() => {}}
      />
    </Collapse>
  )
}

export default PublishBar
